var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 24 23"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5.404 5.504a2.122 2.122 0 0 0 .001-2.949 2.009 2.009 0 0 0-2.89-.001c-.384.391-.599.922-.6 1.475 0 .553.216 1.083.599 1.474.383.392.903.611 1.445.612.542 0 1.062-.22 1.445-.61Zm-3.487 2h4.086v12.507H1.917V7.504Zm6.81 0h3.77v1.97h.054c.524-.96 1.807-1.97 3.72-1.97 3.98 0 4.715 2.527 4.715 5.813v6.694h-3.93v-5.934c0-1.415-.028-3.236-2.043-3.236-2.046 0-2.359 1.54-2.359 3.133v6.037H8.727V7.504Z",
  clipRule: "evenodd"
})));
export default SvgLinkedin;